import { render, staticRenderFns } from "./DynamicCombo.vue?vue&type=template&id=49d2fb00&"
import script from "./DynamicCombo.vue?vue&type=script&lang=js&"
export * from "./DynamicCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d2fb00')) {
      api.createRecord('49d2fb00', component.options)
    } else {
      api.reload('49d2fb00', component.options)
    }
    module.hot.accept("./DynamicCombo.vue?vue&type=template&id=49d2fb00&", function () {
      api.rerender('49d2fb00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/DynamicCombo.vue"
export default component.exports